import { useTranslation } from "react-i18next";
import {
  AddButton,
  ButtonsContainer,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import { useContext, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import { GeneralObj } from "../../../types/company.types";
import { SendFormData, handleError } from "../../../utils/fetch.util";
import { AppsType } from "../../../routes/admin/dashboard/apps/Apps.route";
import { FilePond } from "react-filepond";

type AddAppModalProps = {
  isOpen: boolean;
  onClose: () => void;
  getAllApps: () => void;
};

export default function AddAppModal({
  isOpen,
  onClose,
  getAllApps,
}: AddAppModalProps) {
  const DEFAULT_App: AppsType = {
    id: 0,
    name: "",
    description: "",
    picture_url: "",
    leango_app_service_relationship: [],
  };
  const [logoUrl, setLogoUrl] = useState<any[]>([]);
  const [app, setApp] = useState<AppsType | GeneralObj>(DEFAULT_App);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getValidToken } = useContext(UserContext);
  const { t } = useTranslation();

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setApp({ ...app, [e.target.name]: e.target.value });
  };

  const addApp = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", app.name);
    formData.append("description", app.description);

    const logoUrlModified =
      logoUrl?.length > 0 && logoUrl[0]?.file !== undefined;

    if (logoUrlModified) {
      logoUrl.forEach((item) => formData.append("picture_url", item.file));
    }

    const res = await SendFormData(
      "leango-apps/create-leango-app",
      formData,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    getAllApps();
    setIsLoading(false);
    setLogoUrl([]);
    onClose();
    setApp(DEFAULT_App);
  };

  return (
    <>
      <form
        onSubmit={addApp}
        className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white w-[500px] p-6 !z-[999999] ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <h2 className="text-3xl mb-6 !text-black">{t("contract__add_app")}</h2>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("structure_app_name")}</label>
          <input
            value={app?.name}
            name="name"
            className="border"
            type="text"
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("structure_app_description")}</label>
          <input
            value={app?.description}
            name="description"
            className="border"
            type="text"
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("structure_app_logo_url")}</label>
          <FilePond
            files={logoUrl}
            onupdatefiles={(files) => {
              setLogoUrl(files);
            }}
            allowMultiple={false}
            allowReorder
            allowImagePreview
            allowImageExifOrientation
            maxFiles={1}
            name="files"
            labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
            className={"!mb-0"}
          />
        </div>

        <ButtonsContainer style={{ gap: "2rem" }}>
          <AddButton
            isLoading={isLoading}
            type="submit"
            style={{ background: "black", color: "white" }}
          >
            {t("contract__add_app")}
          </AddButton>
          <CancelButton
            type="button"
            style={{ border: "2px solid black" }}
            onClick={() => {
              onClose();
              setLogoUrl([]);
            }}
          >
            {t("cancelBtn")}
          </CancelButton>
        </ButtonsContainer>
      </form>
      <div
        className={`bg-black ${
          isOpen ? "opacity-60" : "opacity-0 pointer-events-none"
        } fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-500`}
      ></div>
    </>
  );
}
